import { useIs2xResolution } from "./support/use-is-2x-resolution.js";
import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-text.tsx
/**
* icon.24.text
*
* Keywords: typography, letter, serif, font, capital, formatting, character, style
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNNiA2LjVhLjUuNSAwIDAgMSAuNS0uNWgxMWEuNS41IDAgMCAxIC41LjVWOWEuNS41IDAgMCAxLTEgMFY3aC00LjV2MTBoMmEuNS41IDAgMCAxIDAgMWgtNWEuNS41IDAgMCAxIDAtMWgyVjdIN3YyYS41LjUgMCAwIDEtMSAweiIgY2xpcC1ydWxlPSJldmVub2RkIi8+PC9zdmc+)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=1-3111
*/
const Icon24Text = memo(function Icon24Text(props) {
	return useIs2xResolution() ? /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			fillRule: "evenodd",
			d: "M6 6.5a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 .5.5V9a.5.5 0 0 1-1 0V7h-4.5v10h2a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1h2V7H7v2a.5.5 0 0 1-1 0z",
			clipRule: "evenodd"
		})
	}) : /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			fillRule: "evenodd",
			d: "M6 7.5a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0V8h-4v8h1.5a.5.5 0 0 1 0 1h-4a.5.5 0 0 1 0-1H11V8H7v1.5a.5.5 0 0 1-1 0z",
			clipRule: "evenodd"
		})
	});
});
//#endregion
export { Icon24Text };

//# sourceMappingURL=icon-24-text.js.map